import api from './api';

const notificationService = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.post(`/notifications/${id}/read`),
};

export default notificationService;
